import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import URLSearchParams from '@ungap/url-search-params'; // URLSearchParams polyfill for IE11
import * as types from '../../constants/actionTypes';
import { actions as locationDashboardActions } from '../../actions/locationDashboardActions';
import { EXTERNAL_TASK_COMPLETION_PARAMS, QUICK_LINK_TYPES } from '../../constants/constants';
import { Routes } from '../../constants/routes';
import { NavigateToRouteWithDashboardParams } from '../../helpers/routing';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import BarCard from '../Common/BarCard/BarCard';
import Graph100StackedBar from '../Common/Graph100StackedBar';
import './TaskCompletion.scss';

class TaskCompletion extends React.Component {
    constructor(props, context) {
        super(props, context);

        let urlParams = {
            locationKey: '',
            userKey: '',
            sliceName: ''
        }
        const searchParams = new URLSearchParams(props.location.search);
        if (searchParams.has(EXTERNAL_TASK_COMPLETION_PARAMS.LocationKey)) {
            urlParams.locationKey = searchParams.get(EXTERNAL_TASK_COMPLETION_PARAMS.LocationKey);
        }
        if (searchParams.has(EXTERNAL_TASK_COMPLETION_PARAMS.UserKey)) {
            urlParams.userKey = searchParams.get(EXTERNAL_TASK_COMPLETION_PARAMS.UserKey);
        }
        if(searchParams.has(EXTERNAL_TASK_COMPLETION_PARAMS.SliceName)) {
            urlParams.sliceName = searchParams.get(EXTERNAL_TASK_COMPLETION_PARAMS.SliceName);
        }

        this.state = {
            isLoading: true,
            urlParams: urlParams
        }

    }

    componentDidMount = async () => {
        await this.loadTaskCompletion();
    }

    loadTaskCompletion = async () => {
        if(!this.state.urlParams.locationKey){ Notification("error", "Missing Parameter", "Location Key is missing"); this.setState({ isLoading: false }); return; }
        if(!this.state.urlParams.userKey){ Notification("error", "Missing Parameter", "User Key is missing"); this.setState({ isLoading: false }); return; }
        if(!this.state.urlParams.sliceName){ Notification("error", "Missing Parameter", "Slice Name is missing"); this.setState({ isLoading: false }); return; }
        try {
            const response = await this.props.locationDashboardActions.loadExternalTaskCompletionBySection(this.state.urlParams.locationKey, this.state.urlParams.userKey, this.state.urlParams.sliceName);
            if (response.type === types.LOAD_EXTERNAL_TASK_COMPLETION_BY_SUCCESS) {
                this.setState({ cards: response.payload.cards });
            } else if (response.type === types.LOAD_EXTERNAL_TASK_COMPLETION_BY_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onHundyPBarClick = (dataPoint) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, dataPoint.urlParams);
    }

    onQuickLinkClick = (urlParams) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams);
    }

    render() {
        return (
            <LoadingIndicator isLoading={this.state.isLoading}>
                {
                    this.state.cards && this.state.cards.length
                    ?
                        this.state.cards.map(card => {
                            return (
                                <div key={card.id} className="cards">
                                    <BarCard backgroundColor="white">
                                    
                                    <table className="slice-content">
                                        <tbody>
                                            <tr>
                                                <td className="name" onClick={() => this.onCardNameClick(card)}>{card.name}</td>
                                                <td className="hundyp-stacked-bar">
                                                    <Graph100StackedBar data={card.graphData} onClick={this.onHundyPBarClick} />
                                                </td>
                                                <td className="quick-links">
                                                    <div className="quick-links-container">
                                                    {
                                                        card.quickLinks.map((link, index, quickLinks) => {
                                                            // Only put a divider between the quick links, not after all of them
                                                            let quickLinkClass = (index+1 === quickLinks.length) ? "quick-link" : "quick-link divider";
                                                            let clickHandler = this.onQuickLinkClick;
                                                            if (link.total > 0) {
                                                                quickLinkClass += " clickable";
                                                            } else {
                                                                // If a quick link has a total of zero, then don't bother making it clickable.
                                                                // and provide a noop click handler
                                                                clickHandler = () => { /*Do nothing*/ };
                                                            }

                                                            const uiLink = QUICK_LINK_TYPES[link.type];
                                                            if (!uiLink) {
                                                                Notification("error", "Error", `Unsupported Quick Link Type found ${link.type}`);
                                                                return;
                                                            }
                                                            const title = uiLink.title;
                                                            const color = uiLink.color;

                                                            return (
                                                                <div key={link.type} className={quickLinkClass} onClick={() => clickHandler(link.urlParams)}>
                                                                    <span className="total" style={{ color: color}}>{link.total}</span>
                                                                    <span className="title">{title}</span>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </BarCard>
                                </div>
                            )
                        })
                    :
                        <div>No Tasks Found</div>
                }
            </LoadingIndicator>
        )
    }
}

TaskCompletion.propTypes = {
    locationDashboardActions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        locationDashboardActions: bindActionCreators(locationDashboardActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(TaskCompletion);